import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicFileInput } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function ProductUploadTemplate({ productUploadViewStore }) {
    const {
        contentLoading,
        form,
        errorMessage
    } = productUploadViewStore;

    return (
        <ApplicationEditLayout store={productUploadViewStore}>
            <Content loading={contentLoading} >
                <div className='row'>
                    <div className="col col-sml-12 col-lrg-8">
                        <div className='card--max-height card card--form card--primary card--med'>
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicFileInput field={form.$('file')} />
                                </div>
                            </div>
                            {errorMessage && 
                            <React.Fragment>
                                <div className='form__group__label'>Niko Errors:</div>
                                <div disabled className="input input--textarea input--pre">{errorMessage}</div>
                            </React.Fragment>
                            }
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

ProductUploadTemplate.propTypes = {
    productUploadViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ProductUploadTemplate);
